import React from 'react';

import clsx from 'clsx';
import { TextField, makeStyles, InputAdornment } from '@material-ui/core';

import './scss/mui.scss';

const TextFieldComp = ({
  label,
  placeholder,
  type,
  notLabel,
  id,
  name,
  value,
  onChange,
  error,
  helperText,
  disable,
  isBusinessProfileSetting,
  isFeaturedOpt,
  limitErr,
  inputProps,
  pattern,
  smText,
  isFromRO,
  onKeyPress,
  disableUnderline,
  isFromROSidebar,
  isFromAuthorize,
  startAdorn,
  isFromQuickCheckout,
  endAdor,
  termsCondition,
  usedIn,
  autoFocus,
  inputRef = '',
  feedback,
  onFocus = () => {},
  onBlur = () => {},
  onKeyDown = () => {},
  onInput = () => {},
}) => {
  const useStyles = makeStyles({
    root: {
      marginTop: '10px',

      // '&&& ::before': {
      //   borderBottom: '0.25px solid #545b7d',
      // },
    },
    label: {
      fontSize: notLabel ? '14px' : isFeaturedOpt ? '14px' : '13px',
      color: notLabel ? '#263238' : '#545B7D',
      lineHeight: notLabel ? '34px' : '16px',
      fontWeight: notLabel ? '500' : isFeaturedOpt ? 'bold' : 'normal',
    },
    is__error: {
      color: '#FF3636',
    },
    is__error__border: {
      borderColor: '#FF3636 !important',
    },

    sm__text: {
      color: 'rgba(84, 91, 125, 0.5)',
      fontSize: '12px',
    },
    padding__1: {
      padding: '.8rem .5rem',
    },
    customCursor: {
      '& .MuiInputBase-root.Mui-disabled': {
        cursor: 'no-drop', // Change cursor to not-allowed for disabled state
      },
      '& .MuiInputBase-input.Mui-disabled': {
        cursor: 'no-drop',
      },
    },
  });
  const classes = useStyles();
  return (
    <>
      {label && (
        <label
          htmlFor={`estimate-input-${label}`}
          className={clsx(
            classes.label,
            !limitErr ? error && classes.is__error : '', // label will be red only on submit
          )}
        >
          {label}
          {smText && <span className={classes.sm__text}>{smText}</span>}
        </label>
      )}
      <TextField
        autoComplete='off'
        onFocus={(event) => {
          event.target.select();
          onFocus?.();
        }}
        onKeyPress={onKeyPress}
        id={id}
        format='24'
        name={name}
        disabled={disable}
        value={value}
        autoFocus={autoFocus && autoFocus}
        onChange={onChange}
        onKeyDown={(e) => onKeyDown(e)}
        pattern={pattern}
        onBlur={onBlur}
        onInput={onInput}
        InputProps={{
          inputProps: { ...inputProps },
          disableUnderline:
            isFromRO ||
            disableUnderline ||
            usedIn === 'cannedJob' ||
            usedIn === 'carFaxHistory',
          startAdornment: startAdorn && (
            <InputAdornment position='start'>{startAdorn}</InputAdornment>
          ),
          endAdornment: endAdor && (
            <InputAdornment position='end'>{endAdor}</InputAdornment>
          ),
        }}
        // InputProps={(inputProps, { disableUnderline: isFromRO && true })}
        className={clsx(
          classes.root,
          error && classes.is__error__border,
          isBusinessProfileSetting
            ? 'form__field__settings'
            : isFromRO
            ? 'ro__popup__field'
            : isFromROSidebar
            ? 'ro__popup__sidebar__field'
            : isFromQuickCheckout
            ? 'ro__quickcheckout__field'
            : termsCondition
            ? clsx(classes.padding__1, 'ro__quickcheckout__field')
            : usedIn === 'cannedJob' || usedIn === 'carFaxHistory'
            ? 'ro__popup__field listing__search__field'
            : feedback
            ? 'feedback__field'
            : usedIn === 'Supply View' ||
              usedIn === 'Preview' ||
              usedIn === 'Quick Checkout'
            ? 'search_list'
            : 'form_field_estimate',
          disable && classes.customCursor,
        )}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        type={type}
        fullWidth
        multiline={isFromAuthorize && true}
        rows={isFromAuthorize && 4}
        inputRef={inputRef}
      />
    </>
  );
};
export default TextFieldComp;
